import type { NoticeTone } from '@/types/domain';

export function notify(tone: NoticeTone, title: string, message: string) {
  window.dispatchEvent(new CustomEvent('eqs:notice', {
    detail: { id: `${Date.now()}-${Math.random()}`, tone, title, message },
  }));
}
